import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import requestMiddlewares from "../../requestMiddlewares";
import {GetSelectedCompany} from "../../../utils/selectCompany";

export default async function (
  dispatch: Dispatch,
): Promise<IResponse> {
  const cid = GetSelectedCompany();
  if (!cid) {
    return {
      statusCode: 500,
      data: {
        message: 'No company selected'
      }
    }
  }

  const request = new RACARequest('companyMe', 'getMyProfile')
    .setPathValues('COMPANY_ID', cid)

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  return response;
}
